import script from "./laboratoryManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./laboratoryManagement.vue?vue&type=script&setup=true&lang=js"

import "./laboratoryManagement.vue?vue&type=style&index=0&id=4193b156&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4193b156"]])

export default __exports__